import SEOLandingTemplate from './SEOLandingTemplate';

export default function RankCheckerPage() {
  return (
    <SEOLandingTemplate
      title="Google Rank Checker"
      metaTitle="Free Google Rank Checker | Sungresh"
      metaDescription="Check keyword rankings and organic positions for any domain using real SERP data."
      h1="Free Google Rank Checker"
      sub="Check a domain's keyword positions and organic rankings, sourced from live SERP data. See position distribution and which pages bring in the most traffic."
      keywords="rank checker, google rank checker, keyword rank checker, serp checker"
      ctaLink="/domain/organic"
      ctaText="Check Rankings Free"
      features={[
        { icon: '📊', title: 'Keyword Positions', desc: 'Current ranking position for tracked keywords' },
        { icon: '📈', title: 'Position Distribution', desc: 'A breakdown of how many keywords rank in each position range' },
        { icon: '🎯', title: 'Volume & Difficulty', desc: 'Search volume and difficulty for each ranking keyword' },
        { icon: '📄', title: 'Top Pages', desc: 'Which pages on the domain drive the most organic traffic' },
      ]}
      faqs={[
        { q: 'How do I check where I rank for a keyword?', a: 'Enter your domain in Organic Research to see all your ranking keywords and positions at once, or enter a specific keyword in Keyword Overview to see who currently ranks in the top 10 for it.' },
        { q: 'Does this track rankings daily over time?', a: 'Currently this is an on-demand check rather than automated daily tracking with historical trend charts. Run it periodically and note your positions manually if you want to track change over time.' },
        { q: 'What\'s a good place to start improving rankings?', a: 'Look for keywords where you already rank in positions 11-20 — these are often the fastest wins, since a moderate improvement in on-page optimization or a handful of new backlinks can be enough to push them into the top 10.' },
      ]}
    />
  );
}
